import React from 'react';
import styles from './groupButton.module.scss';
export var GroupButton = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'checkbox' : _b, label = _a.label, title = _a.title, name = _a.name, value = _a.value, checked = _a.checked, onChange = _a.onChange, _c = _a.inputNumber, inputNumber = _c === void 0 ? 0 : _c, id = _a.id;
    return (React.createElement("div", { className: styles['checkbox-contained'] },
        React.createElement("label", { className: "".concat(styles['no-description'], " ").concat(styles['no-icon']), title: title, id: id },
            React.createElement("input", { type: type, name: name, value: value, checked: checked, onChange: onChange, "data-input-number": inputNumber }),
            React.createElement(React.Fragment, null,
                React.createElement("span", null, label)))));
};
export default GroupButton;
